import React from 'react';
import Dialog from '@mui/material/Dialog';
import { ModalLayoutPaper } from '../modalLayout';
import { TRANSITION_DURATION, Z_INDEX } from './const';
import { ModalViewBaseProps } from './model';

export const FullscreenView: React.FC<ModalViewBaseProps> = ({ children, onClose, onClosed, isOpen, modalProps, sx }) => {
  return (
    <Dialog
      {...modalProps}
      PaperComponent={ModalLayoutPaper}
      disableEnforceFocus
      onClose={onClose}
      open={isOpen}
      slotProps={{
        transition: { onExited: onClosed },
        paper: {
          sx: {
            m: 0,
            maxHeight: '100dvh',
            maxWidth: '100% !important',
            width: '100dvw',
            height: '100dvh',
          },
        },
      }}
      sx={{ zIndex: Z_INDEX, ...sx }}
      transitionDuration={TRANSITION_DURATION}
    >
      {children}
    </Dialog>
  );
};

export default FullscreenView;
